<script setup>
const props = defineProps([
  "date",
  "timeStart",
  "timeEnd",
  "organizer",
  "place",
  "lector",
  "entrance",
  "entranceMembers",
  "entrancePublic",
]);

const getDate = (datestring) => {
  const date = new Date(datestring);
  return `${date.getDate() < 10 ? "0" : ""}${date.getDate()}.${
    date.getMonth() + 1 < 10 ? "0" : ""
  }${date.getMonth() + 1}.${date.getFullYear()}`;
};

const getIsoDateTime = (dateString, timeStart) => {
	if (!dateString) return '';

	const date = new Date(dateString);

	if (timeStart) {
		const [hours, minutes] = timeStart.split(':').map(Number);
		date.setHours(hours, minutes, 0, 0);
	}

	const pad = (n) => String(n).padStart(2, '0');

	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};
</script>

<template>
  <div class="info pt-12">
    <div class="info__row py-3 border-b border-gray flex" v-if="date">
      <div class="info__row-head min-w-[200px] font-bold">Datum:</div>
      <div class="info__row-body goout-sale-datetime" :data-date="date? getIsoDateTime(date, timeStart) : ''">{{ date ? getDate(date) : "" }}</div>
    </div>
    <div class="info__row py-3 border-b border-gray flex" v-if="timeStart">
      <div class="info__row-head min-w-[200px] font-bold">Čas:</div>
      <div class="info__row-body">
        {{ timeStart }} {{ timeEnd ? ` - ${timeEnd}` : "" }}
      </div>
    </div>
    <div class="info__row py-3 border-b border-gray flex" v-if="organizer">
      <div class="info__row-head min-w-[200px] font-bold">Pořádá:</div>
      <div class="info__row-body">{{ organizer }}</div>
    </div>
    <div class="info__row py-3 border-b border-gray flex" v-if="place">
      <div class="info__row-head min-w-[200px] font-bold">Místo:</div>
      <div class="info__row-body">{{ place }}</div>
    </div>
    <div class="info__row py-3 border-b border-gray flex" v-if="lector">
      <div class="info__row-head min-w-[200px] font-bold">Lektoruje:</div>
      <div class="info__row-body">{{ lector }}</div>
    </div>
    <div class="info__row py-3 border-b border-gray flex" v-if="entrance">
      <div class="info__row-head min-w-[200px] font-bold">Vstup:</div>
      <div class="info__row-body">{{ entrance }}</div>
    </div>
    <div
      class="info__row py-3 border-b border-gray flex"
      v-if="entranceMembers"
    >
      <div class="info__row-head min-w-[200px] font-bold">
        Vstupné pro členy:
      </div>
      <div class="info__row-body">{{ entranceMembers }}</div>
    </div>
    <div class="info__row py-3 border-b border-gray flex" v-if="entrancePublic">
      <div class="info__row-head min-w-[200px] font-bold">
        Vstupné pro veřejnost:
      </div>
      <div class="info__row-body">{{ entrancePublic }}</div>
    </div>
  </div>
</template>
